import { render, staticRenderFns } from "./ReactionList.vue?vue&type=template&id=33c1f1d8&"
import script from "./ReactionList.vue?vue&type=script&lang=js&"
export * from "./ReactionList.vue?vue&type=script&lang=js&"
import style0 from "./ReactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
